export default "__VITE_ASSET__DNsdTwjj__"